



































import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { Field, Button, Dialog, Popup, Toast, Icon } from 'vant';
import { CommentSave } from './api';
import { isWeiXin } from '@/common/ts/common';
Vue.use(Field)
  .use(Button)
  .use(Dialog)
  .use(Popup)
  .use(Icon);
@Component
export default class Six extends Vue {
  option = config.OPTHINES;
  message: string = '';
  autosize = { minHeight: 230 };
  pointOut: boolean = false;
  success: boolean = false;
  created() {
    // if (window.udid) {
    //   this.success = true;
    // }
  }
  enterPage() {
    if (window.udid) {
      const option = {
        dt: '1',
        cid: '12',
        nid: '1129',
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      window.location.href =
        'https://wap.cqcb.com/shangyou_news/LiveDetail?classId=12&newsId=1129';
    }
  }
  async send() {
    if (!this.message) {
      Toast.fail('不能提交空白');
      return;
    }
    if (window.udid) {
      const res = await CommentSave(this.option.voteName, {
        udid: window.udid,
        appkey: window.appkey,
        content: this.message,
      });
      this.successSend(res);
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  successSend(res: any) {
    switch (res.code) {
      case 200:
        // this.success = true;
        Toast.success('提交成功，请等待审核');
        this.message = '';
        break;
      case 203:
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 500:
        Toast.fail(res.msg);
        break;
      case 204:
        Toast.fail(res.msg);
        break;
      case 300:
        Toast.fail(res.msg);
        break;
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
